import { render, staticRenderFns } from "./FeatureCardData.vue?vue&type=template&id=b8f230e6&scoped=true&"
import script from "./FeatureCardData.vue?vue&type=script&lang=js&"
export * from "./FeatureCardData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f230e6",
  null
  
)

export default component.exports